import { useEffect, useState } from 'react'
import styles from '../Home/Home.module.css'
import Reveal from '../Reveal/Reveal'
import { IoMdClose } from "react-icons/io";
import { MdOutlineSimCardDownload } from "react-icons/md";
import { InformationData } from '../../data/InformationData';
import { AppConstants } from '../../AppConstants';

const Home = () => {
    const [currentIndex, setCurrentIndex] = useState(0);
    const [ResumeToggle, setResumeToggle] = useState(false);

    useEffect(() => {
        const length = InformationData.ProfileTags.length;
        const interval = setInterval(() => {
            setCurrentIndex((previndex) => (previndex + 1) % (length))
        }, 3000)

        return () => {
            clearInterval(interval);
        }
    }, [])

    const HandleResumeToggle = () => {
        setResumeToggle(!ResumeToggle);
    }

    return (
        <section id='home'>
            <Reveal>
                <div className="container">
                    <div className={styles.home}>
                        <div className={styles['home-content']}>
                            <div className={styles['home-title']}>
                                <h2>{InformationData.Greetings.HeyIam}</h2>
                                <h1>{InformationData.FirstName}</h1>
                            </div>
                            <div className={styles['text-wrapper']}>
                                <p>
                                    <span className={styles.items}>
                                        {
                                            InformationData.ProfileTags[currentIndex]
                                        }
                                    </span>
                                </p>
                            </div>
                            <div className={styles.links}>
                                <div className={styles.link}>
                                    <a href="#portfolio">{AppConstants.Buttons.ViewProjects}</a>
                                </div>
                                <span className={styles.divider}>{!ResumeToggle && AppConstants.CommonWords.Or}</span>
                                <div className={styles.link}>
                                    {!ResumeToggle && <button type="button" onClick={HandleResumeToggle} className={styles['resume-btn']}>{AppConstants.Buttons.ViewResume}</button>}
                                </div>
                            </div>
                            <div className={styles.scroll}>
                                <a href="#about">
                                    <span></span>
                                </a>
                            </div>
                        </div>
                        {ResumeToggle ? (
                            <div className={styles["resume-cnt"]}>
                                <div className={styles["resume-content"]}>
                                    <IoMdClose className={styles.button} onClick={HandleResumeToggle} size={28} />
                                    <a href={AppConstants.Resume.ResumeLink} download={AppConstants.Resume.ResumeName}><MdOutlineSimCardDownload size={28} /></a>
                                </div>
                                <img src={AppConstants.Images.Resume} alt="" />
                            </div>
                        ) : (
                            <div className={styles.circle}>
                                <div className={styles.content}>
                                    <img src={AppConstants.Images.Avatar} alt={`${InformationData.FirstName} ${InformationData.LastName}`} />
                                    <h2>
                                        {InformationData.FirstName + " " + InformationData.LastName}
                                        <br /> <span />
                                        {InformationData.Designation}
                                    </h2>
                                    <a href="#contact">{AppConstants.Buttons.ContactMe}</a>
                                </div>
                            </div>
                        )
                        }
                    </div>
                </div>
            </Reveal>
        </section>
    )
}

export default Home
